var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNegoitateIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H0V9.54977H16V12ZM16 6.2828H10.0924V4.33527H12.7264C12.1005 3.62961 11.3876 3.0553 10.5876 2.61235C9.7876 2.16941 8.92507 1.94793 8 1.94793C6.6544 1.94793 5.45387 2.34582 4.3984 3.1416C3.34293 3.93738 2.59787 4.98445 2.1632 6.2828H0.1752C0.620533 4.43995 1.5688 2.93211 3.02 1.75926C4.4712 0.58642 6.1312 0 8 0C9.17333 0 10.2852 0.267074 11.3356 0.801224C12.3857 1.33537 13.3047 2.05683 14.0924 2.96559V0.251556H16V6.2828Z",
    fill: "#3253EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegoitateIc);
export default __webpack_public_path__ + "static/media/negoitate_ic.3e49b7cf101b34c94651bf7ff8b1033b.svg";
export { ForwardRef as ReactComponent };